import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { FileUpload } from "primereact/fileupload";
import React, { useRef } from "react";

type AttachMultipleDocsProps = {
  onValueSet: (files: File[]) => void;
  onHide: () => void;
  isEmployeeForm?: boolean;
};

export const AttachMultipleDocsPopup = ({
  onValueSet,
  onHide,
  isEmployeeForm = false,
}: AttachMultipleDocsProps) => {
  const fileInputRef = useRef(null);

  const headerTemplate = (options: any) => {
    const { className, chooseButton } = options;

    return (
      <div
        className={className}
        style={{
          backgroundColor: "transparent",
          display: "flex",
          alignItems: "center",
        }}
      >
        {chooseButton}
      </div>
    );
  };

  const addFiles = () => {
    //@ts-ignore
    const files = fileInputRef.current.getFiles();
    onValueSet(files);
    onHide();
  };

  const attachFilePopupFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        className="p-button-text p-button-secondary"
        onClick={onHide}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        className="p-button-text p-button-primary"
        type="button"
        onClick={addFiles}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={true}
      onHide={onHide}
      header="Select files"
      footer={attachFilePopupFooter}
      style={{ minWidth: "500px" }}
    >
      <FileUpload
        ref={fileInputRef}
        accept={
          isEmployeeForm
            ? "application/pdf,.doc,.docx,.jpg,.jpeg,.png,.heic"
            : "application/pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.heic"
        }
        multiple
        customUpload
        headerTemplate={headerTemplate}
      />
    </Dialog>
  );
};
